module.exports = __webpack_public_path__ + "media/song2.fa416925.mp3";